import { createContext, useContext } from 'react';
import type { AuthContextValue } from './types';

/** Internal React context. Consume via {@link useAuth} — do not import this directly. */
export const AuthContext = createContext<AuthContextValue | null>(null);

/**
 * Internal hook used by {@link useAuth}.
 * Throws if called outside an {@link AuthProvider} tree.
 */
export function useAuthContext(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
